import { useDynamicEntity } from './useDynamicEntity';
import { useAuth } from './index';

const useJobTypes = () => {
  const { user } = useAuth();
  const dynamicHook = useDynamicEntity({
    entityType: 'jobTypes',
    gqlEntityKey: 'job_types',
    queryName: 'GET_JOB_TYPES_QUERY',
    createMutation: 'CREATE_JOB_TYPE_MUTATION',
    updateMutation: 'UPDATE_JOB_TYPE_MUTATION',
    deleteMutation: 'DELETE_JOB_TYPE_MUTATION',
    updateVariableName: 'set',
    transformData: (jobType) => ({
      ...jobType,
      company_name: jobType.company?.name || `Company ${jobType.company_id}`,
      name: jobType.name,
      description: jobType.description,
      isProjectBased: jobType.is_project_based,
      isProjectBasedText: jobType.is_project_based ? 'Evet' : 'Hayır',
      statusGroup: jobType.status_group,
      status: jobType.status ? 'active' : 'inactive',
      companyId: jobType.company_id,
    }),
    transformFormData: (formData) => ({
      name: formData.name,
      description: formData.description || null,
      is_project_based:
        formData.isProjectBased === false
          ? false
          : (formData.isProjectBased || false),
      status_group: formData.statusGroup || 'standard',
      status: formData.status === 'active',
      company_id: formData.companyId,
    }),
    customWhereCondition:
      user?.role === 'ROOT' ? {} : { company_id: { _eq: user?.companyId } },
  });
  return {
    ...dynamicHook,
    isRootUser: user?.role === 'ROOT',
  };
};

export { useJobTypes };
